import type {
  PopulationAgeGroup,
  PopulationComparison,
  PopulationKind,
  PopulationPeriod,
  PopulationRiskLevel,
} from '@behuman/core-contract'

/** Display labels for the PD-1715 vocabularies (the values themselves come from core-contract). */

export const PERIOD_LABELS: Record<PopulationPeriod, string> = {
  'last-30-days': 'Last 30 days',
  'last-90-days': 'Last 90 days',
  'last-365-days': 'Last 365 days',
  'previous-calendar-year': 'Previous calendar year',
  'year-to-date': 'Year to date',
  custom: 'Custom',
}

export const COMPARISON_LABELS: Record<PopulationComparison, string> = {
  'previous-period': 'Previous matched period',
  'same-dates-last-year': 'Same dates last year',
}

export const AGE_GROUP_LABELS: Record<PopulationAgeGroup, string> = {
  '18-plus': '18+',
  '45-64': '45–64',
  '65-plus': '65+',
}

export const RISK_LEVEL_LABELS: Record<PopulationRiskLevel, string> = {
  high: 'High',
  medium: 'Medium',
}

export const KIND_LABELS: Record<PopulationKind, string> = {
  gap: 'Care gaps',
  risk: 'Risks',
}

export const STATUS_LABELS = {
  improving: 'Improving',
  stable: 'Stable',
  declining: 'Declining',
} as const

export const stateLabel = (state: string) => (state === 'unknown' ? 'Unknown' : state)

export const options = <T extends string>(labels: Record<T, string>) =>
  (Object.keys(labels) as T[]).map((value) => ({ value, label: labels[value] }))
